import { invoiceAmounts } from '../../utils/invoiceAmounts';
import { formatRupiah, POPUP_BLOCKED_MESSAGE } from '../../utils/printHelper';
import { findCompany } from '../../utils/signatures';
import { printVoucherDP, printVoucherInternal } from '../../utils/voucherTemplate';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Label } from '../ui/label';
import { Printer } from 'lucide-react';
import { toast } from 'sonner';

export function VoucherPrintDialog({ companies, printedBy = '', printVoucherPembayaran, setShowVoucherDialog, setVoucherKeterangan, showVoucherDialog, voucherKeterangan, voucherTarget }) {
  // Voucher internal/OPR butuh perusahaan (pembebanan & penanda tangan).
  const missingCompany = voucherTarget?.type === 'internal' && !voucherTarget?.data?.company_id;

  const handlePrint = () => {
    // Dialog ditutup DULU supaya pengembalian fokus Radix tidak berebut dengan
    // jendela cetak; print() sendiri menunggu dokumen siap (printWhenReady).
    setShowVoucherDialog(false);
    const company = findCompany(companies, voucherTarget.data.company_id);
    const opened = voucherTarget.type === 'invoice'
      ? printVoucherPembayaran(voucherTarget.data, voucherKeterangan)
      : voucherTarget.type === 'dp'
        ? printVoucherDP(voucherTarget.data, voucherKeterangan, { company, printedBy })
        : printVoucherInternal(voucherTarget.data, voucherKeterangan, { company });
    if (opened === false) {
      toast.error(POPUP_BLOCKED_MESSAGE);
      setShowVoucherDialog(true); // keterangan yang sudah diketik tetap ada
    }
  };

  return (
    <Dialog open={showVoucherDialog} onOpenChange={setShowVoucherDialog}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Print Voucher Pembayaran</DialogTitle>
        </DialogHeader>
        {voucherTarget && (
          <div className="space-y-4">
            <div className="bg-slate-50 p-3 rounded-lg text-sm">
              <p className="font-semibold">{voucherTarget.data.invoice_number || voucherTarget.data.request_number || voucherTarget.data.dp_number}</p>
              {voucherTarget.type === 'invoice' && (
                <p className="text-slate-500">No. Voucher: <span className="font-mono">{voucherTarget.data.voucher_number || '-'}</span></p>
              )}
              <p className="text-slate-500">
                Nilai Dibayarkan: Rp {formatRupiah(
                  voucherTarget.type === 'invoice'
                    ? invoiceAmounts(voucherTarget.data).nilaiDibayarkan
                    : voucherTarget.type === 'dp'
                      ? (voucherTarget.data.amount || 0) - (voucherTarget.data.admin_bank || 0)
                      : (voucherTarget.data.amount || 0) - (voucherTarget.data.pph_amount || 0) - (voucherTarget.data.admin_bank || 0)
                )}
              </p>
            </div>
            <div className="space-y-2">
              <Label>Keterangan Tambahan (Opsional)</Label>
              <textarea
                className="flex min-h-[80px] w-full rounded-md border border-input bg-white px-3 py-2 text-sm uppercase"
                value={voucherKeterangan}
                onChange={(e) => setVoucherKeterangan(e.target.value.toUpperCase())}
                placeholder="MASUKKAN KETERANGAN TAMBAHAN..."
                data-testid="voucher-keterangan-input"
              />
            </div>
            {missingCompany && (
              <p className="text-xs text-[#800000]" data-testid="voucher-needs-company">Isi perusahaan dulu lewat tombol edit detail sebelum mencetak voucher.</p>
            )}
            <div className="flex gap-2">
              <Button variant="outline" onClick={() => setShowVoucherDialog(false)} className="flex-1">Batal</Button>
              <Button
                className="flex-1 bg-purple-600 hover:bg-purple-700"
                onClick={handlePrint}
                disabled={missingCompany}
                data-testid="print-voucher-confirm"
              >
                <Printer className="h-4 w-4 mr-2" /> Print Voucher
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
